import { arrayOf, bool, shape, string } from 'prop-types';
import React from 'react';
import SemanticHeader from '../../platformui/Chapter/semantic-header';

const DescriptionList = (props) => {
  let count = null;
  return (
    <div className="description-list">
      {props.Heading && (
        <SemanticHeader isH3={props.isH3}>{props.Heading}</SemanticHeader>
      )}
      <p className="description-list__preamble">{props.Preamble}</p>
      <ul>
        {props.List?.map((item, key) => {
          props.ShowNumber && count++;
          return (
            <DescriptionListItem
              {...props}
              {...item}
              isH4={
                props.isH3 !== undefined &&
                props.isH3 &&
                props.Heading !== undefined
              }
              number={count}
              key={key}
            />
          );
        })}
      </ul>
    </div>
  );
};
const DescriptionListItem = (props) => {
  return (
    <li className="description-list__item">
      <div className="description-list__item__content">
        <div className="list-item-header-container">
          {props.number && (
            <span>
              <p>{props.number}</p>
            </span>
          )}
          {props.Heading && (
            <SemanticHeader
              isH4={props.isH4}
              isH3={
                (!props.isH4 && props.isH3) || (!props.isH3 && props.Heading)
              }
            >
              {props.Heading}
            </SemanticHeader>
          )}
        </div>
        <div dangerouslySetInnerHTML={{ __html: props.Description }}></div>
      </div>
    </li>
  );
};

DescriptionList.propTypes = {
  Heading: string,
  Preamble: string,
  ShowNumber: bool,
  List: arrayOf(
    shape({
      Heading: string,
      Description: string,
    })
  ),
};

export default DescriptionList;
